export default __webpack_public_path__ + "static/media/02_jerabiny_d-min.6cc7c063.jpg";